import { render } from "./AddPermissionGroup.vue?vue&type=template&id=1568fdac&scoped=true&ts=true"
import script from "./AddPermissionGroup.vue?vue&type=script&lang=ts"
export * from "./AddPermissionGroup.vue?vue&type=script&lang=ts"

import "./AddPermissionGroup.vue?vue&type=style&index=0&id=1568fdac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1568fdac"]])

export default __exports__